$(document).ready( function(){
	if ($('.accordion').length > 0){
        $(document).find('.accordion').each(function(e){
        	var dom = $(this);
        	dom.find('.accordion__item__header').on('click', function(e){
        		$(this).closest('.accordion__item').toggleClass('accordion__item--collapsed');
        	});
        });
    }
});